import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsOfOfficeEquipmentStorageSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  safeAndSecureOfficeEquipmentStorageSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/office-equipment-storage-page'

interface OfficeEquipmentStoragePageProps {}

const OfficeEquipmentStoragePage: React.FC<OfficeEquipmentStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
      w-[324px] h-[218px] 
      md-mn:w-[380px] md-mn:h-[286px] 
      lg:!w-[448px] lg:!h-[313px] 
      xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[281px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[186px] w-[252px] h-[44px]'
        className='xl-min:[&>div:first-child]:!max-w-[745px] lg-mn:[&>div:first-child]:max-w-[436px]'
      />
      <HelperSection
        isBgDark
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[350px] md-mn:h-[196px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            md-mn:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            `}
        sectionTitleClassName='md-mn:[&_p]:w-[60%]'
        buttonClassName='xl-min:!w-[265px] w-[265px]'
      />
      <HelperSection
        {...safeAndSecureOfficeEquipmentStorageSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[350px] md-mn:h-[196px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            md-mn:[&>div>div:last-of-type>div]:!flex-row-reverse
            [&>div>div:last-of-type>div]:flex-col
            `}
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        sectionTitleClassName='[&_p]:md-mn:w-[600px]'
      />
      <WhyWeSection
        {...whyWeSectionContent}
        className='
          [&_article]:bg-transparent
          [&_article]:border-none 
          [&_button]:md-mn:w-[335px] 
          [&_button]:w-[303px]
          '
        sectionTitleClassName='md-mn:[&_p]:w-[440px] [&_p]:w-[90%]'
        imgClassName='w-[130px] h-[130px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...benefitsOfOfficeEquipmentStorageSectionContent}
        className='[&_article]:text-center [&_article_div]:self-center'
        sectionTitleClassName='[&_p]:md-mn:w-[600px] [&_p]:w-[90%] [&_h2]:md-mn:w-full [&_h2]:w-[80%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-full
          [&_h3]:w-[80%] 
          [&_h3]:mx-auto
          xl-min:[&_button]:!w-[281px]
          lg-mn:[&_button]:w-[236px]
          md-mn:[&_button]:w-[229px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default OfficeEquipmentStoragePage
